<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="logOut.emit()">
    <mat-icon>logout</mat-icon>
    <span>Log Out</span>
  </button>
</mat-menu>
